import { render } from "./labInfo.vue?vue&type=template&id=1d059144&scoped=true"
import script from "./labInfo.vue?vue&type=script&lang=js"
export * from "./labInfo.vue?vue&type=script&lang=js"

import "./labInfo.vue?vue&type=style&index=0&id=1d059144&lang=scss&scoped=true"

import exportComponent from "D:\\projects\\gitlab\\DemoLab\\DemoLab-data\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d059144"]])

export default __exports__